import { createContext, useContext, type ReactNode } from 'react';
import { useJsApiLoader } from '@react-google-maps/api';

const GOOGLE_MAPS_API_KEY =
  (typeof import.meta !== 'undefined' && import.meta.env?.VITE_GOOGLE_MAP_API) ||
  'AIzaSyB64E05RIf1JNgdVAFnhWB-dHUwe7T_m48';

const LIBRARIES: ('places')[] = ['places'];

interface GoogleMapsContextType {
  isLoaded: boolean;
  loadError?: Error;
}

const GoogleMapsContext = createContext<GoogleMapsContextType>({
  isLoaded: false,
});

export const useGoogleMapsStatus = () => useContext(GoogleMapsContext);

export function GoogleMapsProvider({ children }: { children: ReactNode }) {
  const { isLoaded, loadError } = useJsApiLoader({
    id: 'speedyssey-google-maps',
    googleMapsApiKey: GOOGLE_MAPS_API_KEY,
    libraries: LIBRARIES,
  });

  return (
    <GoogleMapsContext.Provider value={{ isLoaded, loadError }}>
      {children}
    </GoogleMapsContext.Provider>
  );
}

// Hook that can also be used directly in any component with fallback
export function useGoogleMapsLoaded() {
  const context = useContext(GoogleMapsContext);
  // If wrapped in provider and loaded, use context
  if (context.isLoaded) {
    return { isLoaded: true, loadError: context.loadError };
  }

  // Fallback loader if outside provider
  const { isLoaded, loadError } = useJsApiLoader({
    id: 'speedyssey-google-maps',
    googleMapsApiKey: GOOGLE_MAPS_API_KEY,
    libraries: LIBRARIES,
  });

  return { isLoaded, loadError };
}
